import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const state = {
    isLoading: false,
    showMask: false,
    showSlidebar: false,
    COMMON: null,
    mAppUrl:'',
    timeDiff: 0,
    authRequiredDlgVisible: false,
    user: null,
    userFeature: null,
    pwdIsEasy: false,
    isKefu: false
};

export const types = {
    UPDATE_LOADING: 'UPDATE_LOADING',
    UPDATE_MASK: 'UPDATE_MASK',
    UPDATE_DIRECTION: 'UPDATE_DIRECTION',
    SHOW_SLIDEBAR: 'SHOW_SLIDEBAR',
    SET_COMMON: 'SET_COMMON',
    SET_M_APP_URL: 'SET_M_APP_URL',
    SET_SERVER_TIME: 'SET_SERVER_TIME',
    SHOW_AUTH_REQUIRED_DLG: 'showAuthRequiredDlg',
    SET_USER: 'SET_USER',
    SET_USER_FEATURE: 'SET_USER_FEATURE',
    SET_PWD_STATUS: 'SET_PWD_STATUS',
    SET_KEFU: 'SET_KEFU'
};

const mutations = {
    [types.UPDATE_LOADING] (state, status) {
        state.isLoading = status
    },
    [types.UPDATE_MASK] (state, status) {
        state.showMask = status
    },
    [types.UPDATE_MASK] (state, status) {
        state.showMask = status
    },
    [types.SHOW_SLIDEBAR] (state, status) {
        state.showSlidebar = status
    },
    [types.SHOW_AUTH_REQUIRED_DLG] (state, status) {
        state.authRequiredDlgVisible = status
    },
    [types.SET_COMMON] (state, data) {
        state.COMMON = data
    },
    [types.SET_M_APP_URL] (state, data) {
        state.mAppUrl = data
    },
    [types.SET_SERVER_TIME] (state, data) {
        state.timeDiff = data - new Date().getTime();
    },
    [types.SET_USER](state, user) {
        state.user = user
    },
    [types.SET_USER_FEATURE](state, features) {
        state.userFeature = features
    },
    [types.SET_PWD_STATUS](state, status){
        state.pwdIsEasy = status
    },
    [types.SET_KEFU](state, statu) {
        state.isKefu = statu
    }
};

const actions = {};

const getters = {
    currentTime(state){
        var local = new Date().getTime();
        return state.timeDiff + local;
    }
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    strict: false
})



// WEBPACK FOOTER //
// ./src/vuex/index.js